import { useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";

export const addToColumnDefinitions = (
  columnDefinitions,
  propertyName,
  columns,
) =>
  columnDefinitions.map((colDef) => {
    const column = (columns || []).find((col) => col.id === colDef.id);
    const savedValue = column?.[propertyName];
    const isValidPercentage =
      typeof savedValue === "string" && /^\d+(\.\d+)?%$/.test(savedValue);
    let resolvedValue;
    if (isValidPercentage) {
      resolvedValue = Math.round(
        (parseFloat(savedValue) / 100) * window.innerWidth,
      );
    } else if (typeof savedValue === "number" && savedValue > 0) {
      resolvedValue = savedValue;
    } else {
      resolvedValue = colDef[propertyName];
    }
    return {
      ...colDef,
      [propertyName]: resolvedValue,
    };
  });

export const mapWithColumnDefinitionIds = (
  columnDefinitions,
  propertyName,
  items,
) =>
  columnDefinitions.map(({ id }, i) => ({
    id,
    [propertyName]: items[i],
  }));

export function useColumnWidths(storageKey, columnDefinitions) {
  const [widths, saveWidths] = useLocalStorage(storageKey);

  function handleWidthChange(event) {
    const pixelWidths = event.detail.widths;
    const total = pixelWidths.reduce((sum, w) => sum + w, 0);
    if (total === 0 || !window.innerWidth) return;
    // Persist as a % of the viewport so addToColumnDefinitions reverses it with the same window.innerWidth basis on load.
    const percentages = mapWithColumnDefinitionIds(
      columnDefinitions,
      "width",
      pixelWidths.map((w) => `${((w / window.innerWidth) * 100).toFixed(2)}%`),
    );
    saveWidths(percentages);
  }
  const memoDefinitions = useMemo(() => {
    return addToColumnDefinitions(columnDefinitions, "width", widths);
  }, [widths, columnDefinitions]);

  return [memoDefinitions, handleWidthChange];
}
